export default __webpack_public_path__ + "media/images/deepl_logo-36a3b23e.svg";